import { parseHostnameFromEnv } from './brandFromHost'

const WYSEHUB_PUBLIC_ENTRY_PATHS = new Set([
  '/',
  '/recover-password',
  '/reset-password',
  '/unauthorised',
  '/unlockconfirmation',
])

export function getWysehubPortalHostname(): string {
  return parseHostnameFromEnv(process.env.NEXT_PUBLIC_WYSEHUB_PORTAL_HOST)
}

export function getWysehubAdminHostname(): string {
  return parseHostnameFromEnv(process.env.NEXT_PUBLIC_WYSEHUB_ADMIN_HOST)
}

export function isWysehubPortalHost(hostname: string): boolean {
  const configuredHost = getWysehubPortalHostname()
  return !!configuredHost && hostname.toLowerCase() === configuredHost
}

export function isWysehubAdminHost(hostname: string): boolean {
  const configuredHost = getWysehubAdminHostname()
  return !!configuredHost && hostname.toLowerCase() === configuredHost
}

export function isWysehubAdminPath(pathname: string): boolean {
  return pathname === '/admin' || pathname.startsWith('/admin/')
}

export function getWysehubAdminAliasPath(pathname: string): string | null {
  if (pathname === '/rates') {
    return '/admin/rates'
  }

  if (pathname === '/source_rates') {
    return '/admin/source-rates'
  }

  return null
}

export function isWysehubPublicEntryPath(pathname: string): boolean {
  return WYSEHUB_PUBLIC_ENTRY_PATHS.has(pathname)
}
